import { Action } from '@ngrx/store';
import { Email } from '../../shared/models/email';
import * as viewModels from '../../shared/models';

export const LOAD_SENT_EMAILS = '[Shared Sent Email Collection] Load Sent Emails';
export const LOAD_SENT_EMAILS_FAILURE = '[Shared Sent Email Collection] Load Sent Emails Failure';
export const LOAD_SENT_EMAILS_SUCCESS = '[Shared Sent Email Collection] Load Sent Emails Success';
export const LOAD_EMAIL_BODY = '[Shared Sent Email Collection] Load Emails Body';
export const LOAD_EMAIL_BODY_FAILURE = '[Shared Sent Email Collection] Load Emails Body Failure';
export const LOAD_EMAIL_BODY_SUCCESS = '[Shared Sent Email Collection] Load Emails Body Success';
export const LOAD_EMAIL_BY_ID = '[Shared Sent Email Collection] Load Email By Id';
export const LOAD_EMAIL_BY_ID_FAILURE = '[Shared Sent Email Collection] Load Email By Id Failure';
export const LOAD_EMAIL_BY_ID_SUCCESS = '[Shared Sent Email Collection] Load Email By Id Success';
export const RESET = '[Shared Sent Email Collection] Reset';

export class LoadPayload {
  constructor(public lookup: viewModels.SentEmailsLookup) {}
}

export class LoadSentEmailsAction implements Action {
  readonly type = LOAD_SENT_EMAILS;

  constructor(public payload: LoadPayload) {}
}

export class LoadSentEmailsFailureAction implements Action {
  readonly type = LOAD_SENT_EMAILS_FAILURE;
}

export class LoadSentEmailsSuccessPayload {
  emails: Array<Email>;
  totalItems: number;
}

export class LoadSentEmailsSuccessAction implements Action {
  readonly type = LOAD_SENT_EMAILS_SUCCESS;

  constructor(public payload: LoadSentEmailsSuccessPayload) {}
}

export class LoadEmailBodyAction implements Action {
  readonly type = LOAD_EMAIL_BODY;

  constructor(public payload: string) {}
}

export class LoadEmailBodyFailureAction implements Action {
  readonly type = LOAD_EMAIL_BODY_FAILURE;
}

export class LoadEmailBodySuccessPayload {
  body: string;
}

export class LoadEmailBodySuccessAction implements Action {
  readonly type = LOAD_EMAIL_BODY_SUCCESS;

  constructor(public payload: LoadEmailBodySuccessPayload) {}
}

export class LoadEmailByIdAction implements Action {
  readonly type = LOAD_EMAIL_BY_ID;

  constructor(public payload: string) {}
}

export class LoadEmailByIdFailureAction implements Action {
  readonly type = LOAD_EMAIL_BY_ID_FAILURE;
}

export class LoadEmailByIdSuccessPayload {
  email: Email;
}

export class LoadEmailByIdSuccessAction implements Action {
  readonly type = LOAD_EMAIL_BY_ID_SUCCESS;

  constructor(public payload: LoadEmailByIdSuccessPayload) {}
}

export class ResetAction implements Action {
  readonly type = RESET;
}

export type Actions =
  | LoadSentEmailsAction
  | LoadSentEmailsFailureAction
  | LoadSentEmailsSuccessAction
  | LoadEmailBodyAction
  | LoadEmailBodySuccessAction
  | LoadEmailBodyFailureAction
  | LoadEmailByIdAction
  | LoadEmailByIdSuccessAction
  | LoadEmailByIdFailureAction
  | ResetAction;
